import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import './ContentSkeleton.css';

const ContentSkeleton = ({ timeRemaining = 0, totalTime = 1, onExit, isBackgroundGeneration = false, isPageVisible = true, onRetry }) => {
  const safeTotal = Math.max(1, totalTime);
  const clampedRemaining = Math.max(0, timeRemaining);
  const progress = Math.min(100, Math.max(0, ((safeTotal - clampedRemaining) / safeTotal) * 100));

  const getCaption = () => {
    if (isBackgroundGeneration && !isPageVisible) {
      return 'Continuing in background...';
    }
    if (isBackgroundGeneration && isPageVisible) {
      return 'Checking status...';
    }
    if (progress < 20) return 'Preparing...';
    if (progress < 50) return 'Generating...';
    if (progress < 80) return 'Polishing...';
    return 'Almost done...';
  };

  const minutes = Math.floor(clampedRemaining / 60);
  const seconds = (clampedRemaining % 60).toString().padStart(2, '0');

  const radius = 36;
  const circumference = 2 * Math.PI * radius;

  return (
    <div className="w-full flex justify-center pointer-events-auto">
      <div className="w-full max-w-sm rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-4 text-gray-200">
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm font-medium">
            {isBackgroundGeneration ? 'Background Processing' : 'Creating Content'}
          </p>
          <div className="flex items-center gap-2">
            {isBackgroundGeneration && onRetry && (
              <button
                type="button"
                onClick={onRetry}
                aria-label="Retry generation"
                className="inline-flex items-center justify-center h-8 px-3 rounded-full bg-purple-500/20 hover:bg-purple-500/30 border border-purple-500/30 transition text-xs font-medium"
                title="Retry generation"
              >
                Retry
              </button>
            )}
            {!isBackgroundGeneration && (
              <button
                type="button"
                onClick={onExit}
                aria-label="Stop generation"
                className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 transition"
                title="Stop generation"
              >
                <FaTimes className="text-xs" />
              </button>
            )}
          </div>
        </div>

        <div className="flex items-center gap-4">
          {/* <div className="relative shrink-0" aria-hidden>
            <svg width="84" height="84" viewBox="0 0 84 84" className="-rotate-90">
              <circle cx="42" cy="42" r={radius} stroke="rgba(255,255,255,0.12)" strokeWidth="6" fill="none" />
              <circle
                cx="42"
                cy="42"
                r={radius}
                stroke="url(#cs-gradient)"
                strokeWidth="6"
                fill="none"
                strokeLinecap="round"
                style={{
                  strokeDasharray: `${circumference}`,
                  strokeDashoffset: `${circumference * (1 - progress / 100)}`,
                  transition: 'stroke-dashoffset 0.3s ease'
                }}
              />
              <defs>
                <linearGradient id="cs-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#a855f7" />
                  <stop offset="100%" stopColor="#ec4899" />
                </linearGradient>
              </defs>
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-sm font-semibold">{Math.round(progress)}%</span>
            </div>
          </div> */}

          <div className="flex-1 min-w-0">
            <div className="text-sm text-gray-300 truncate" aria-live="polite">{getCaption()}</div>
            <div className="mt-2 h-1.5 w-full rounded-full bg-white/10 overflow-hidden">
              <motion.div
                className="h-1.5 rounded-full bg-gradient-to-r from-purple-500 to-pink-500"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.3 }}
              />
            </div>
            {/* {!isBackgroundGeneration && (
              <div className="mt-2 text-xs text-gray-400">Time left {minutes}:{seconds}</div>
            )} */}
            {isBackgroundGeneration && (
              <div className="mt-2 text-xs text-gray-400">
                {isPageVisible ? 'Checking for updates...' : 'Return to this tab to see progress'}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentSkeleton; 